class ContactForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[data-submit-button]');
    this.submitLabel = this.submitButton.querySelector('[data-label]');
    this.successMessage = this.querySelector('[data-success-message]');
    this.genericError = this.querySelector('[data-generic-error]');
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  clearErrors() {
    this.querySelectorAll('[data-error-for]').forEach((el) => {
      el.textContent = '';
    });
    this.genericError.hidden = true;
  }

  async onSubmit(event) {
    event.preventDefault();
    this.clearErrors();
    this.successMessage.hidden = true;

    const formData = new FormData(this.form);
    const payload = {
      name: formData.get('name') || '',
      email: formData.get('email') || '',
      phone: formData.get('phone') || '',
      subject: formData.get('subject') || '',
      message: formData.get('message') || '',
      source_page: window.location.pathname,
    };

    const originalLabel = this.submitLabel.textContent;
    this.submitButton.disabled = true;
    if (this.dataset.sendingLabel) this.submitLabel.textContent = this.dataset.sendingLabel;

    try {
      const response = await fetch(this.dataset.proxyPath, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (data.ok) {
        this.form.reset();
        this.successMessage.hidden = false;
      } else if (data.errors) {
        Object.entries(data.errors).forEach(([field, message]) => {
          const el = this.querySelector(`[data-error-for="${field}"]`);
          if (el) el.textContent = message;
        });
      } else {
        this.genericError.hidden = false;
      }
    } catch (error) {
      this.genericError.hidden = false;
    } finally {
      this.submitButton.disabled = false;
      this.submitLabel.textContent = originalLabel;
    }
  }
}

customElements.define('contact-form', ContactForm);
